/*
 *
 * PagoPaDownloadAllPopup
 *
 * @version 1.0.0
 * @author Emanuele Motta
 * @since 10-Dec-2025
*/

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { DocumentXLS, DocumentCVS } from '@nexidigital/iconlibrary'
import './PagoPaDownloadAllPopup.scss'

const PagoPaDownloadAllPopup = (props) => {
  const { actions, isDownloadLoading, fromDate, toDate, terminals, minAmount, maxAmount, iuv, stateCompany } = props

  const [downloadingFormat, setDownloadingFormat] = useState(null)

  // Reset loading state
  useEffect(() => {
    if (!isDownloadLoading) setDownloadingFormat(null)
  }, [isDownloadLoading])

  const startDownload = (format) => {
    setDownloadingFormat(format)

    if (actions && actions.doDownloadAllTransactions) {
      actions.doDownloadAllTransactions({
        fromDate,
        toDate,
        terminals,
        minAmount,
        maxAmount,
        iuv,
        stateCompany,
        fileFormat: format
      })
    }
  }

  return (
    <Toggle>
      <MerchantModal
        onClose={() => actions.doHidePopup()}
        primaryAction={() => startDownload('CSV')}
        primaryButtonLoading={downloadingFormat === 'CSV'}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        primaryIcon={<DocumentCVS size='24' type='line' />}
        primaryButtonTertiary
        secondaryAction={() => startDownload('EXCEL')}
        secondaryButtonLoading={downloadingFormat === 'EXCEL'}
        secondaryButtonLabel={formattedMessage.secondaryButtonLabel}
        secondaryIcon={<DocumentXLS size='24' type='line' />}
        secondaryButtonTertiary
        closeLabel={formattedMessage.close}
        title={formattedMessage.title}
        customAnalyticsDescription={formattedMessage.description}
        description={formattedMessage.formatInfoMessage}
      />
    </Toggle>
  )
}

PagoPaDownloadAllPopup.propTypes = {
  actions: PropTypes.object,
  isDownloadLoading: PropTypes.bool,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  terminals: PropTypes.array,
  minAmount: PropTypes.number,
  maxAmount: PropTypes.number,
  iuv: PropTypes.string,
  stateCompany: PropTypes.string,
  fileFormat: PropTypes.string
}

PagoPaDownloadAllPopup.defaultProps = {
  actions: {},
  isDownloadLoading: false,
  fromDate: '',
  toDate: '',
  terminals: [],
  minAmount: 0,
  maxAmount: 10000,
  iuv: '',
  stateCompany: '',
  fileFormat: 'EXCEL'
}

export default PagoPaDownloadAllPopup
